// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__krrJW","input":"MGInputCheckbox_input__NKyNm","visual":"MGInputCheckbox_visual__1rBp6","icon":"MGInputCheckbox_icon__dACsV"};